/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('AddressList', {
    attrs: {
      "isChiose": true
    },
    on: {
      "on-chiose": function ($event) {
        _vm.$emit('on-ok', $event), _vm.currValue = false;
      }
    }
  })], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };